import MaintenanceTable from "./MaintenanceTable";

export default MaintenanceTable;